module.exports = __webpack_public_path__ + "static/media/payment-policy.e3b1413d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/payment-policy.pdf
// module id = 284
// module chunks = 0